import React, { Suspense } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import Navbar from "../../components/admin/navbar/index";
import Sidebar from "../../components/admin/sidebar/index";
import Footer from "../../components/admin/footer/Footer";
import routes, {
	konten,
	beranda,
	tentang,
	media,
	pengaturan,
} from "../../routes";
import NotFound from "../../components/user/NotFound";

const RouteFallback = () => (
	<div className="flex items-center justify-center p-20">
		<div className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-brand-500 border-r-transparent" />
	</div>
);

// Combine all route categories
const allRoutes = [
	...routes,
	...konten,
	...beranda,
	...tentang,
	...media,
	...pengaturan,
];

export default function Admin(props) {
	const { ...rest } = props;
	const location = useLocation();
	const [open, setOpen] = React.useState(true);
	const [currentRoute, setCurrentRoute] = React.useState("Not Found");

	React.useEffect(() => {
		window.addEventListener("resize", () =>
			window.innerWidth < 1200 ? setOpen(false) : setOpen(true)
		);
	}, []);

	React.useEffect(() => {
		getActiveRoute(allRoutes);
	}, [location.pathname]);

	const getActiveRoute = (routes) => {
		let activeRoute = "Not Found";

		routes.forEach((route) => {
			// Replace ":id" with any dynamic value using regex
			const pathToMatch =
				route.layout + "/" + route.path.replace(":id", "[^/]+");

			// Create a regular expression to match the route
			const regex = new RegExp(pathToMatch);

			if (window.location.href.match(regex)) {
				setCurrentRoute(route.name);
				activeRoute = route.name;
			}
		});

		return activeRoute;
	};

	const getActiveNavbar = (routes) => {
		let activeNavbar = false;
		for (let i = 0; i < routes.length; i++) {
			if (
				window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
			) {
				return routes[i].secondary;
			}
		}
		return activeNavbar;
	};

	const getRoutes = (routes) => {
		return routes.map((prop, key) => {
			if (prop.layout === "/admin") {
				return (
					<Route path={`/${prop.path}`} element={prop.component} key={key} />
				);
			} else {
				return null;
			}
		});
	};

	document.documentElement.dir = "ltr";
	return (
		<div className="flex h-full w-full">
			<Sidebar open={open} onClose={() => setOpen(false)} />
			{/* Navbar & Main Content */}
			<div className="h-full w-full bg-lightPrimary dark:!bg-navy-900 xl:ml-[290px]">
				{/* Main Content */}
				<main className={`mx-[12px] h-full flex-none transition-all md:pr-2`}>
					{/* Routes */}
					<div className="h-full">
						<Navbar
							onOpenSidenav={() => setOpen(true)}
							logoText={"Web Kota Kabupaten"}
							brandText={currentRoute}
							secondary={getActiveNavbar(allRoutes)}
							{...rest}
						/>
						<div className="pt-5s mx-auto h-full min-h-[84vh] p-2 md:pr-2">
							<Suspense fallback={<RouteFallback />}>
								<Routes>
									{getRoutes(allRoutes)}
									<Route
										path="/"
										element={<Navigate to="/admin/dashboard" replace />}
									/>
									<Route path="*" element={<NotFound />} />
								</Routes>
							</Suspense>
						</div>
						<div className="p-3">
							<Footer />
						</div>
					</div>
				</main>
			</div>
		</div>
	);
}
